import React from "react"
import * as style from "./style.module.css"

const Component = ({
  kvVideo,
  text,
  img,
  background,
  backgroundColor,
  fadeOut,
}) => {
  let element = null
  let element001 = null
  let element002 = null
  let element003 = null
  let element003Style = {
    height: "100%",
    width: "100%",
    backgroundColor: backgroundColor,
  }
  let element004 = null

  if (text) {
    element001 = (
      <span
        className={style.kvTitle}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    )
  } else if (img) {
    element001 = <img className={style.kvLogo} src={img} alt="KV画像" />
  }
  if (background) {
    element002 = (
      <img className={style.kvBackground} src={background} alt="KV画像" />
    )
  } else if (backgroundColor) {
    element003 = <div style={element003Style} />
  }
  if (fadeOut) {
    element004 = <div className={style.darkScreen}></div>
  }

  if (kvVideo) {
    element = (
      <section className={style.kvVideoSection}>
        <video src={kvVideo} muted autoPlay loop playsInline />
      </section>
    )
  } else if (background) {
    element = (
      <div className={style.kvWrapper}>
        {element001}
        {element004}
        {element002}
        {element003}
      </div>
    )
  }

  return <>{element}</>
}

export default Component
